import { render, staticRenderFns } from "./InputStockOpname.vue?vue&type=template&id=288f50fb&scoped=true"
import script from "./InputStockOpname.vue?vue&type=script&lang=js"
export * from "./InputStockOpname.vue?vue&type=script&lang=js"
import style0 from "./InputStockOpname.vue?vue&type=style&index=0&id=288f50fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f50fb",
  null
  
)

export default component.exports